import course from './course';
import courseSpecial from './courseSpecial';
import listen from './listen';
import listenManager from './listenManager';
import listenManagerAssignOrg from './listenManagerAssignOrg';
import listenManagerGenerate from './listenManagerGenerate';
import listenManagerPublish from './listenManagerPublish';
import listenManagerEntryList from './listenManagerEntryList';
import listenManagerEntryPage from './listenManagerEntryPage';
import listenManagerView from './listenManagerView';
import listenManagerCustomized from './listenManagerCustomized';
import listenManagerMonitor from './listenManagerMonitor';
import listenedManagerMonitor from './listenedManagerMonitor';
import listenManagerMonitorNew from './listenManagerMonitorNew';
import listenManagerResultList from './listenManagerResultList';
import ListenCoursePlan from './ListenCoursePlan';
import listenWeightResultTotal from './listenWeightResultTotal';
import listenWeightResultList from './listenWeightResultList';
import courseExImport from './courseExImport';
import listenOrgImport from './listenOrgImport';
import listenPlanImport from './listenPlanImport';
import listenManagerEntryModalList from './listenManagerEntryModalList';
import listenTaskManage from './listenTaskManage';
import schoolCalendar from './schoolCalendar';
import schoolCalendarImport from './schoolCalendarImport';

export default {
    courseSpecial,
    course,
    listen,
    listenManager,
    listenManagerAssignOrg,
    listenManagerGenerate,
    listenManagerPublish,
    listenManagerEntryList,
    listenManagerEntryPage,
    listenManagerView,
    listenManagerCustomized,
    listenManagerMonitor,
    listenedManagerMonitor,
    listenManagerResultList,
    ListenCoursePlan,
    listenWeightResultTotal,
    listenWeightResultList,
    courseExImport,
    listenManagerMonitorNew,
    listenOrgImport,
    listenPlanImport,
    listenManagerEntryModalList,
    listenTaskManage,
    schoolCalendar,
    schoolCalendarImport
}